import BaseOnboarding from 'onboarding/onboardings/baseonboarding';
import InstrumentsInfoStep from 'onboarding/onboardings/ProjectsListDetailInfoOnboarding/steps/InstrumentsInfoStep';
import PlacementsInfoStep from 'onboarding/onboardings/ProjectsListDetailInfoOnboarding/steps/PlacementsInfoStep';
import ProjectInfoStep from 'onboarding/onboardings/ProjectsListDetailInfoOnboarding/steps/ProjectInfoStep';

import nextFrame from 'utils/nextFrame';
import router from 'router';
import appEventBus from 'appEventBus';
import tracker from 'tracking';

class ProjectsListDetailInfoOnboarding extends BaseOnboarding {
  static get name () {
    return 'projects-detail-onboarding';
  }

  static get trackingName () {
    return 'onboarding_projects_series_2';
  }

  static async checkCondition () {
    const route = router.currentRoute;
    const routeName = route.name;

    return routeName === 'projectsList' || routeName === 'projectDetails';
  }

  steps () {
    return [
      {
        target: '#page-layout-content .project-dashboard-page',
        attachToHighlight: false,
        header: 'Информация о проекте',
        component: ProjectInfoStep,
        params: {
          customArrowStyle: {opacity: 0},
          placement: 'right',
          enableScrolling: false
        },
        width: '408px',
        highlightTarget: '#page-layout-content .project-dashboard-page',
        highlightOptions: {
          shape: 'square',
          maskBorder: 4,
          maskSizeOffsetX: 4,
          maskSizeOffsetY: 8
        }
      },
      {
        target: '#page-layout-content .tabs .tabs__placements-tab',
        attachToHighlight: true,
        header: 'Размещения',
        component: PlacementsInfoStep,
        params: {
          placement: 'bottom',
          enableScrolling: true
        },
        width: '408px',
        highlightTarget: '#page-layout-content .tabs .tabs__placements-tab',
        highlightOptions: {
          shape: 'square',
          maskBorder: 4,
          maskSizeOffsetX: 4,
          maskSizeOffsetY: 8
        },
        events: {
          off () {
            nextFrame(() => {
              document.querySelector('.tabs__tools-tab .menu__title').click();
            });
          }
        }
      },
      {
        target: '.project-tools__menu',
        attachToHighlight: true,
        header: 'Инструменты',
        component: InstrumentsInfoStep,
        params: {
          placement: 'left',
          enableScrolling: true
        },
        width: '408px',
        highlightTarget: '.project-tools__menu',
        highlightOptions: {
          shape: 'square',
          maskBorder: 4,
          maskSizeOffsetX: 8,
          maskSizeOffsetY: 8
        },
        events: {
          off: () => {
            appEventBus.$emit('AUTORUN_ONBOARDING_COMPLETE');
            tracker.track('onboarding_projects_complete', this.trackingParams);
            window.ymReachGoal('ONBOARDING_PROJECTS_COMPLETE');
          }
        }
      }
    ];
  }
}

export default ProjectsListDetailInfoOnboarding;
